import * as FilePond from 'filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import 'filepond/dist/filepond.min.css';

FilePond.registerPlugin(FilePondPluginFileValidateType);

const trashIcon = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10 16L10 11" stroke="#B7B7B7" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M14 16L14 11" stroke="#B7B7B7" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M2 6H22V6C20.7538 6 20.1308 6 19.6667 6.26795C19.3626 6.44349 19.1102 6.69596 18.9346 7C18.6667 7.4641 18.6667 8.08718 18.6667 9.33333V17C18.6667 18.8856 18.6667 19.8284 18.0809 20.4142C17.4951 21 16.5523 21 14.6667 21H9.33333C7.44771 21 6.50491 21 5.91912 20.4142C5.33333 19.8284 5.33333 18.8856 5.33333 17V9.33333C5.33333 8.08718 5.33333 7.4641 5.06538 7C4.88985 6.69596 4.63737 6.44349 4.33333 6.26795C3.86923 6 3.24615 6 2 6V6Z" stroke="#B7B7B7" stroke-width="1.8" stroke-linecap="round"/>
  <path d="M10.0681 2.37059C10.1821 2.26427 10.4332 2.17033 10.7825 2.10332C11.1318 2.03632 11.5597 2 12 2C12.4403 2 12.8682 2.03632 13.2175 2.10332C13.5668 2.17033 13.8179 2.26427 13.9319 2.37059" stroke="#B7B7B7" stroke-width="1.8" stroke-linecap="round"/>
  </svg>`

window.getFilesPond = (selector) => {
  return FilePond.find(document.querySelector(selector)).getFiles()
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll('.input-file__container').length > 0) {
    document.querySelectorAll('.input-file__container').forEach(item => {
      const inputElement = item.querySelector('input[type="file"]');
      let pathIcon = inputElement.dataset.pathIcon

      const pond = FilePond.create(inputElement, {
        styleButtonRemoveItemPosition: 'right',
        stylePanelLayout: 'integrated',
        iconRemove: trashIcon,
      });

      pond.on('addfile', (error, file) => {
        if (error) {
          console.error(error)
          return
        }

        const fileInfo = item.querySelector('.filepond--file-info');
        const fileInfoIcon = `<div class="input-file__icon"><img src='${pathIcon}${file.fileExtension}-icon.svg' alt='Иконка файла'></div>`
        fileInfo.insertAdjacentHTML('afterbegin', fileInfoIcon)
      })
    })
  }
})

